import { z } from 'zod';

export const BaseSchema = z.object({
    table: z.string(),
    section_id: z.number(),
});
